import { BASE_API_URL } from '@env';
import { useMutation } from 'react-query';

interface ResetPasswordRequest {
  email: string;
  otp: string;
  new_password: string;
}

interface ResetPasswordResponse {
  message: string;
}

export function useResetPassword() {
  const mutation = useMutation<ResetPasswordResponse, Error, ResetPasswordRequest>(
    async (data: ResetPasswordRequest) => {
      const response = await fetch(`${BASE_API_URL}users/auth/reset-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'accept': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.detail || 'Failed to reset password');
      }

      return response.json();
    }
  );

  return mutation;
}
